import React from 'react'
import Slider from 'react-slick' // for the image slider
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import Image from 'next/image'
import { ExternalLinkIcon, XIcon } from '@heroicons/react/outline'
// import Link from 'next/link'

const ZoomModal = ({ images, currentImageIndex, onClose }) => {
    const settings = {
        initialSlide: currentImageIndex,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        swipe: true, // Enable swipe
        touchMove: true, // Enable touch movement
    }

    return (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-75 flex justify-center items-center">
            <div className="relative w-full max-w-2xl rounded-lg justify-center text-center">
                <Slider {...settings}>
                    {images.map(
                        (image, idx) =>
                            image.url && (
                                <div
                                    key={idx}
                                    className="text-center flex justify-center items-center">
                                    <div className="flex justify-between mx-10">
                                        <p className="text-white text-left py-2 pt-0 text-xl ">
                                            {image.name}
                                        </p>
                                        <button
                                            className="rounded-full text-gray-500 hover:text-black"
                                            onClick={onClose}>
                                            <XIcon className="h-6 w-6 text-red-700 z-50" />
                                        </button>
                                    </div>
                                    <Image
                                        src={image.url}
                                        alt={image.name}
                                        width={600}
                                        height={635}
                                        className="rounded-lg"
                                        loading="lazy"
                                    />
                                    <a
                                        href={image.link}
                                        className="flex justify-center text-xs items-center py-2 bg-white rounded-lg w-44 my-4 m-auto text-black">
                                        <span className="mr-2">
                                            edit this template
                                        </span>
                                        <ExternalLinkIcon className="h-4 w-4" />
                                    </a>
                                    {/* </Link> */}
                                </div>
                            ),
                    )}
                </Slider>
            </div>
        </div>
    )
}

export default ZoomModal
